import { Component, EventEmitter, Output, Input, OnDestroy } from '@angular/core'
import { addMinutes, format } from 'date-fns'
import { Subject, throttleTime, map, takeUntil } from 'rxjs'

@Component({
  selector: 'app-range-picker',
  templateUrl: './range-picker.component.html',
  standalone: false,
})
export class RangePickerComponent {
  @Input() timestamp: Date | undefined
  @Input() timespan: number | undefined = 0
  @Input() min: string | undefined = '-30'
  @Input() max: string | undefined = '30'
  @Input() step: number | undefined = 15
  @Input() disabled = true

  @Output() timeSpanToggled = new EventEmitter<string>()

  calculateTimeStamp(step: number) {
    return this.timestamp ? format(addMinutes(this.timestamp, Number(step)), 'HH:mm') : undefined
  }
}
